<template>
  <Card>
    <h1 slot="Title">Expired State</h1>
    <div slot="MainContent">
      <ul>
        <li>
          An appropriation lapses into the expired state during the fiscal year following the unexpired state and remains in the expired state for five years.
        </li>
        <li>
          In this state, the appropriation can be used to disburse or adjust existing obligations only.
        </li>
        <li>
          No additional obligations will be incurred without major command approval. 
        </li>
      </ul>
      <p><b>Expired</b>: 1 Oct 2020 - 30 Sep 2025</p>
    </div>
    <div slot="Notes">
      <p style="margin-top:0pt;margin-bottom:0pt;margin-left:0in;text-align:left;"><span style="font-size: 16px; font-family: Calibri; color: rgb(255, 255, 255); font-weight: bold;">Expired State</span></p>
      <p style="margin-top:0pt;margin-bottom:0pt;margin-left:0in;text-align:left;"><span style="color: rgb(255, 255, 255);"><span style="font-size: 16px; font-family: Calibri; font-weight: bold;">REF: 37-100&gt;22-FY-3&nbsp;</span></span></p>
      <p style="margin-top:0pt;margin-bottom:0pt;margin-left:0in;text-align:left;"><span style="color: rgb(255, 255, 255);"><span style="font-size: 16px; font-family: Calibri; font-weight: bold;">EXPIRED.</span><span style="font-size: 16px; font-family: Calibri;">&nbsp; During this state, you may disburse or adjust existing obligations only. &nbsp;No additional obligations may be incurred without approval from the Major Command (MACOM). &nbsp;An appropriation lapses into the expired state the fiscal year following the unexpired state and will remain in the expired state for five years. In the&nbsp;</span><u><span style="font-size: 16px; font-family: Calibri;">expired state</span></u></span><span style="font-size: 16px; font-family: Calibri; color: rgb(255, 255, 255);">, only disbursements can be made from the appropriation. &nbsp;Obligations during this state must be approved by the Major Command (MACOM).</span></p>
    </div>
  </Card>
</template>

<script>
import Card from '../../../components/Card.vue';

export default {

  components: {
    Card
  },
  name: 'TestPage',
  
  data() {
    return {
    }
  }
  
}
</script>